// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanelSection from 'viewmodel/AwPanelSectionViewModel';
import AwLabel from 'viewmodel/AwLabelViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/DesCatalogPartSummaryService', () => import('js/DesCatalogPartSummaryService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "imports": [],
    "data": {
        "name": {
            "displayName": "{{i18n.name}}",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "false",
            "dbValue": "",
            "dispValue": ""
        },
        "manufacturer": {
            "displayName": "{{i18n.manufacturer}}",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "false",
            "dbValue": "",
            "dispValue": ""
        },
        "partNo": {
            "displayName": "{{i18n.partNo}}",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "false",
            "dbValue": "",
            "dispValue": ""
        },
        "verp": {
            "displayName": "{{i18n.verp}}",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "false",
            "dbValue": "",
            "dispValue": ""
        },
        "sortingKeys": {
            "displayName": "{{i18n.sortingKeys}}",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "false",
            "dbValue": "",
            "dispValue": ""
        }
    },
    "lifecycleHooks": {
        "onMount": "loadSummary"
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "attachments": {
            "type": "string"
        },
        "partid": {
            "type": "string"
        },
        "provider": {
            "type": "string"
        },
        "catalogspaceid": {
            "type": "string"
        },
        "locale": {
            "type": "string"
        }
    },
    "actions": {
        "loadSummary": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "provider": "{{props.provider}}"
                        },
                        "appBaseUrl": "assets",
                        "query": "query GetPartDetails($getPartDetailsInput: GetPartDetailsInput) { getPartDetails(getPartDetailsInput: $getPartDetailsInput) }",
                        "variables": {
                            "getPartDetailsInput": {
                                "attachments": "{{props.attachments}}",
                                "catalogspaceId": "{{props.catalogspaceid}}",
                                "locale": "{{props.locale}}",
                                "partId": "{{props.partid}}",
                                "provider": "{{props.provider}}"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionId": "{{props.accsessionid}}"
            },
            "outputData": {
                "part": "data.data.getPartDetails.part"
            },
            "events": {
                "success": [
                    {
                        "name": "desSetProperties",
                        "eventData": {
                            "eventName": "desSetProperties",
                            "eventData": "{{data.part}}"
                        }
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "SetProperties": {
            "actionType": "JSFunction",
            "method": "SetProperties",
            "inputData": {
                "vmo": "{{data}}",
                "props": "{{props}}",
                "part": "{{parameters.eventData}}"
            },
            "deps": "js/DesCatalogPartSummaryService"
        }
    },
    "onEvent": [
        {
            "eventId": "desSetProperties",
            "action": "SetProperties",
            "inputArgs": {
                "eventData": "{{eventData.eventData}}"
            }
        }
    ],
    "i18n": {
        "name": [
            "DesCatalogPartSummaryMessages"
        ],
        "manufacturer": [
            "DesCatalogPartSummaryMessages"
        ],
        "partNo": [
            "DesCatalogPartSummaryMessages"
        ],
        "verp": [
            "DesCatalogPartSummaryMessages"
        ],
        "sortingKeys": [
            "DesCatalogPartSummaryMessages"
        ],
        "properties": [
            "DesCatalogPartSummaryMessages"
        ]
    },
    "_viewModelId": "DesCatalogProperties",
    "_uniqueViewModelId": "DesCatalogProperties",
    "ctx": {}
};

    /*
    <aw-panel-section caption="{{i18n.properties}}">
    <aw-label prop="data.name"></aw-label>
    <aw-label prop="data.manufacturer"></aw-label>
    <aw-label prop="data.partNo"></aw-label>
    <aw-label prop="data.verp"></aw-label>
    <aw-label prop="data.sortingKeys"></aw-label>
</aw-panel-section>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanelSection caption={AwParseService.instance( "i18n.properties" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
        <AwLabel {...getField("data.name", fields, $index, null, null )}>
        </AwLabel>
        <AwLabel {...getField("data.manufacturer", fields, $index, null, null )}>
        </AwLabel>
        <AwLabel {...getField("data.partNo", fields, $index, null, null )}>
        </AwLabel>
        <AwLabel {...getField("data.verp", fields, $index, null, null )}>
        </AwLabel>
        <AwLabel {...getField("data.sortingKeys", fields, $index, null, null )}>
        </AwLabel>
    </AwPanelSection>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;